import { render } from "./UpdateProfile.vue?vue&type=template&id=a8c92c6a&scoped=true"
import script from "./UpdateProfile.vue?vue&type=script&lang=js"
export * from "./UpdateProfile.vue?vue&type=script&lang=js"

import "./UpdateProfile.vue?vue&type=style&index=0&id=a8c92c6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8c92c6a"]])

export default __exports__